export const primary = '#56c7fa';
export const secondary = "#060335";
export const light = '#fbfbff';
export const neutral = '#f4f6ff';
export const dark = '';
export const lightShadow = '#eaeaea';
export const darkShadow = '#dbdbdb';
export const danger = '#FA8956';